import schoolClubs from "../assets/clubs-video.mp4"

export default function SchoolClubs(){
    return(
        <>
        <div className="flex flex-col items-center gap-8">
            <div>
                <video className="h-[400px] mobile_video_height shadow-2xl my-8" src={schoolClubs} autoPlay loop={true} muted alt="not found"/>
            </div>     
        </div>
        </>
    )
}